import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageJCBGoldCardMocks: BannerImage = {
  alt: 'Delta SkyMiles JCB Gold Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-jcb-gold-card.png',
  show: true,
  position: 'right'
};

export const BannerContentJCBGoldCardMocks: GenericLabel = {
  title: 'Delta SkyMiles JCB Gold Card',
  subtitle: ''
};

export const BannerJCBGoldCardMocks: CardCarouselBanner = {
  labels: BannerContentJCBGoldCardMocks,
  image: BannerImageJCBGoldCardMocks
};
